// src/components/features/Elevation/components/ElevationStep2Gate.jsx
// Gate Selection — 3 real gate types (folder "7.Gate category radio" —
// "Radio" naam hai, isliye radio/single-select UI hi rakha gaya hai)

import ElevationRadioStep from "./shared/ElevationRadioStep";
import { GATE_IMAGES } from "../../../../assets/Elevation/elevationAssets";

const GATE_OPTIONS = GATE_IMAGES.map((img) => ({ ...img, sub: undefined }));

export default function ElevationStep2Gate(props) {
  return (
    <ElevationRadioStep
      {...props}
      title="Gate Selection"
      subtitle="Choose the gate type for your property entrance"
      options={GATE_OPTIONS}
      fieldKey="elevationGate"
    />
  );
}
